import * as React from "react";
import { cn } from "../../lib/utils";
import { DisplayHeading } from "../atoms/display-heading";

export interface EmptyStateProps
	extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
	heading: React.ReactNode;
	description?: React.ReactNode;
	icon?: React.ReactNode;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
	({ className, heading, description, icon, children, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cn(
					"flex flex-col items-center justify-center text-center px-6 py-8",
					className,
				)}
				{...props}
			>
				{icon && <div className="mb-3 text-gray-300 dark:text-gray-700">{icon}</div>}
				<DisplayHeading
					size="md"
					className="!text-gray-700 dark:!text-gray-300 mb-1"
				>
					{heading}
				</DisplayHeading>
				{description && (
					<p className="text-[11px] text-gray-500 dark:text-gray-500 max-w-[260px] leading-relaxed tracking-tight">
						{description}
					</p>
				)}
				{children}
			</div>
		);
	},
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
